import { render, staticRenderFns } from "./Paginas.vue?vue&type=template&id=32ac5146&"
import script from "./Paginas.vue?vue&type=script&lang=js&"
export * from "./Paginas.vue?vue&type=script&lang=js&"
import style0 from "./Paginas.vue?vue&type=style&index=0&id=32ac5146&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports